import {useUserAttributes} from "../hooks/useUserAttributes.ts";
import {UserLayout} from "./UserLayout.tsx";
import {PublicLayout} from "./PublicLayout.tsx";
import {signInWithRedirect} from "aws-amplify/auth";
import {useSearchParams} from "react-router-dom";


export const AppLayout = () => {

    const [searchParams] = useSearchParams();

    const next = searchParams.get('next');


    const {
        email
    } = useUserAttributes()


    if (email) {
        return (<UserLayout/>);

    } else {

        if (next && next === 'authn') {
            signInWithRedirect()
        }

        return <PublicLayout/>

    }

};
